module.exports = __webpack_public_path__ + "img/product7.8c11e231.png";